import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    poserlist: [],
    updatePosterDialog: false
  },
  getters: {
  
  },
  mutations: {
    setposerlist(state, payload) {
      state.poserlist = payload;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    }
  },
  actions: {
    uploadPoster(context, data) {
      return api.uploadPoster(data);
    },
    updatePoster(context, data) {
      return api.updatePoster(data);
    },
    list({ commit }, data) {
      api.getList(data).then(({ data }) => {
        commit('setposerlist', data);
      });
    },
    remove({ commit }, id) {
      return new Promise(resolve => {
        api.removeList(id).then(res => {
          resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('poster', store);
